runfun = {
	floorMod: function(a, n) {
		return a - n * Math.floor(a / n);
	},
	interpolation: function(x, y, g1, g2, g3, g4) {
		//把一个格子算成1*1的方块，x,y就是方块中某一点的坐标
		//g1,g2,g3,g4是左上，右上，左下，右下四个点
		d1 = (1 - x) * (1 - y);
		d2 = x * (1 - y);
		d3 = y * (1 - x);
		d4 = x * y;
		//d1--d4表示四个点对最终值的影响程度
		return g1 * d1 + g2 * d2 + g3 * d3 + g4 * d4;
	},
	isValue: function(x) {
		return x !== null && x !== undefined;
	},
	//获取rgb颜色
	getrgba: function(v, color, gradient) {
		//因为数据总计算量很大，而且速度要求很高，所以这里能节省时间就节省时间
		//这里采用二分法查找
		var this_rgb = [0, 0, 0, 0];
		var a = 255;
		if(v == null) {
			return this_rgb;
		}
		//违反验证
		if(v <= color.v[0]) {
			return [color.r[0], color.g[0], color.b[0], 0];
		}else if(v<=color.v[1]){
			a = (v-color.v[0])/(color.v[1]-color.v[0])*300
		} else if(v >= color.v[color.v.length - 1]) {
			var n = color.v.length - 1;
			return [color.r[n], color.g[n], color.b[n], 255];
		}
		//中间查找
		var low = 0;
		var high = color.v.length - 1;

		while(low < high) {
			var mid = parseInt((low + high + 1) / 2);
			if(color.v[mid] == v) {
				this_rgb = [color.r[mid], color.g[mid], color.b[mid], a];
				break;
			} else if(color.v[mid] > v) {
				high = mid;
			} else {
				low = mid;
			}
			if((high - low) == 1) {
				//				//位于两个值中间，就对颜色进行插值
				var x = (v - color.v[low]) / (color.v[high] - color.v[low]);
				var mid_r = (color.r[high] - color.r[low]) / 4;
				var mid_g = (color.g[high] - color.g[low]) / 4;
				var mid_b = (color.b[high] - color.b[low]) / 4;
				if(x <= gradient) {

					var y = x / gradient
					var r = color.r[low] + mid_r * y
					var g = color.g[low] + mid_g * y
					var b = color.b[low] + mid_b * y
					this_rgb = [parseInt(r), parseInt(g), parseInt(b), a];
					break;
				} else if(x > gradient && x < 1 - gradient) {
					var y = (x - gradient) / (1 - 2 * gradient);
					var r = color.r[low] + mid_r + 2 * mid_r * y
					var g = color.g[low] + mid_g + 2 * mid_g * y
					var b = color.b[low] + mid_b + 2 * mid_b * y
					this_rgb = [parseInt(r), parseInt(g), parseInt(b), a];
					break;
				} else {
					var y = (x + gradient - 1) / gradient;
					var r = color.r[low] + mid_r * y + 3 * mid_r;
					var g = color.g[low] + mid_g * y + 3 * mid_g;
					var b = color.b[low] + mid_b * y + 3 * mid_b;
					this_rgb = [parseInt(r), parseInt(g), parseInt(b), a];
					break;
				}
			}
		}
		return this_rgb;

	},
}
L.Layer.RunImg = L.Layer.extend({
	initialize: function(data, option) {
		this.grid_info = {}
		this.color = option.color;
		this.gradient = option.gradient;
		this.grid_info.lat_min = data.latmin;
		this.grid_info.lat_max = data.latmax;
		this.grid_info.lon_min = data.lonmin;
		this.grid_info.nlat = data.nlat;
		this.grid_info.nlon = data.nlon;
		this.grid_info.interval = data.interval;
		this.grid = [];
		this.now = 0;
		this.isplay = false;
		this.playing = null;
		this.playInterval = 600||option.playInterval;
		this.buildGrid(data.data, 0);
	},
	onAdd: function(map) {
		this._map = map;
		this._canvas = L.DomUtil.create("canvas", 'leaflet-layer');
		this.ctx = this._canvas.getContext("2d");
		this._map._panes.overlayPane.appendChild(this._canvas);
		var animated = this._map.options.zoomAnimation && L.Browser.any3d;
		L.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));
		this._map.on("zoomanim", this.zoomEvent, this);
		this._map.on("moveend", this.moveEvent, this);
		map.fire("moveend");
	},
	addData: function(datas,type) {
		this.grid = [];
		for(var i = 0; i < datas.length; i++) {
			this.buildGrid(datas[i], i)
		}
		if(type=="last"){
			this.now = datas.length-1;
		}else{
			this.now = 0;
		}
		this.isplay = true;
	},
	onRemove:function(){
		this._map._panes.overlayPane.removeChild(this._canvas);
		this._map.off("zoomanim", this.zoomEvent, this);
		this._map.off("moveend", this.moveEvent, this);
	},
	play: function() {
		clearInterval(this.playing);
		this.playing = setInterval(function() {
			if(this.now < this.grid.length) {
				this.setNum(this.now);
				this.now++;
			} else {
				this.now =  0;
				this.setNum(this.now);
			}
		}.bind(this), this.playInterval)
	},
	stop:function(){
		clearInterval(this.playing);
	},
	setNum: function(num) {
		this.now = num;
		this.build_columns();
		this.ctx.putImageData(this.colors, 0, 0);
	},
	moveEvent: function() {
		var size = this._map.getSize();
		this.bwidth = size.x;
		this.bheight = size.y;
		this.colors = this.ctx.createImageData(this.bwidth, this.bheight);
		this.build_columns();
		var mbounds = this._map.getBounds();
		//清空画布 重新定义位置
		this._canvas.width = size.x;
		this._canvas.height = size.y;
		var new_position = this._map.latLngToLayerPoint([mbounds._northEast.lat, mbounds._southWest.lng]);
		L.DomUtil.setPosition(this._canvas, new_position);
		this.ctx.putImageData(this.colors, 0, 0);
	},
	zoomEvent: function() {
		var map = this._map;
		var center = map._animateToCenter;
		var zoom = map._animateToZoom;
		var scale = map.getZoomScale(zoom);
		var bound = map.getBounds();
		var yun_lat1 = bound._northEast.lat;
		var yun_lon1 = bound._northEast.lng;
		var yun_lat2 = bound._southWest.lat;
		var yun_lon2 = bound._southWest.lng;
		var new_position = map.latLngToLayerPoint([yun_lat1, yun_lon2]);
		// -- different calc of offset in leaflet 1.0.0 and 0.0.7 thanks for 1.0.0-rc2 calc @jduggan1
		var offset = L.Layer ? map._latLngToNewLayerPoint(map.getBounds().getNorthWest(), zoom, center) : map.getCenterOffset(center).multiplyBy(-scale).subtract(map.getMapPanePos());
		L.DomUtil.setTransform(this._canvas, offset, scale);
	},
	buildGrid: function(data, n) {
		//获取左上角的经纬度点
		data = data.reverse();
		this.grid[n] = data;
//		var isContinuous = Math.floor(data.nlon * data.interval) >= 360;
		//x方向的跨度乘以x方向的数量是否大于360
//		for(var j = 0; j < this.grid_info.nlat; j++) {
//			var row = [];
//			for(var i = 0; i < this.grid_info.nlon; i++) {
//				row[i] = data[j][i];
//			}
//			if(isContinuous) {
//				// For wrapped grids, duplicate first column as last column to simplify interpolation logic
//				row.push(row[0]);
//			}
//			this.grid[n][j] = row;
//		}
		//grid是一个三维数组
		//第一纬表示行数
		//第二纬表示列数
		//第三纬表示每一个网格点的uv
	},
	build_columns: function() {
		var by = 0;
		while(by < this.bheight) {
			bx = 0;
			while(bx < this.bwidth) {
				var thisrgb = this.get_color(bx, by);
				if(thisrgb != null) {
					this.colors.data[(by * this.bwidth + bx) * 4 + 0] = thisrgb[0];
					this.colors.data[(by * this.bwidth + bx) * 4 + 1] = thisrgb[1];
					this.colors.data[(by * this.bwidth + bx) * 4 + 2] = thisrgb[2];
					this.colors.data[(by * this.bwidth + bx) * 4 + 3] = thisrgb[3];
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 0] = thisrgb[0];
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 1] = thisrgb[1];
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 2] = thisrgb[2];
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 3] = thisrgb[3];
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 0] = thisrgb[0];
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 1] = thisrgb[1];
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 2] = thisrgb[2];
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 3] = thisrgb[3];
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 0] = thisrgb[0];
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 1] = thisrgb[1];
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 2] = thisrgb[2];
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 3] = thisrgb[3];
				} else {
					this.colors.data[(by * this.bwidth + bx) * 4 + 0] = 0;
					this.colors.data[(by * this.bwidth + bx) * 4 + 1] = 0;
					this.colors.data[(by * this.bwidth + bx) * 4 + 2] = 0;
					this.colors.data[(by * this.bwidth + bx) * 4 + 3] = 0;
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 0] = 0;
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 1] = 0;
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 2] = 0;
					this.colors.data[(by * this.bwidth + bx + 1) * 4 + 3] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 0] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 1] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 2] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx) * 4 + 3] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 0] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 1] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 2] = 0;
					this.colors.data[((by + 1) * this.bwidth + bx + 1) * 4 + 3] = 0;
				}
				bx += 2;
			}
			by += 2;
		}
	},
	get_color: function(x, y, n) {
		var coord = this._map.containerPointToLatLng([x, y]);
		if(coord) {
			var lat = coord.lat;
			var lng = coord.lng;
			var value = this.get_value(lat, lng);
			var rgba = runfun.getrgba(value, this.color, this.gradient);
			return rgba;
		}
		return null;
	},
	get_value: function(lat, lon) {

		//如果风场网格数据不存在，就不执行
		if(!this.grid[this.now]) return null;
		//λ, φ分别是每个网格点的经度和纬度
		var i = runfun.floorMod(lon - this.grid_info.lon_min, 360) / this.grid_info.interval; // calculate longitude index in wrapped range [0, 360)
		//lat_min应该是上面的纬度，大的一个
		var j = (this.grid_info.lat_max - lat) / this.grid_info.interval; // calculate latitude index in direction +90 to -90
		//计算网格点在从上到下，从左到右，以最小刻度为0的第几个经纬度格点上
		var fi = Math.floor(i), //格点的上一行
			ci = fi + 1; //格点的下一行
		var fj = Math.floor(j), //格点的前一列
			cj = fj + 1; //格点的后一列
		var row;
		if(row = this.grid[this.now][fj]) {
			var g1 = row[fi];
			var g2 = row[ci];

			if(runfun.isValue(g1) && runfun.isValue(g2) && (row = this.grid[this.now][cj])) {
				var g3 = row[fi];
				var g4 = row[ci];
				//计算出格点周围4个点
				if(runfun.isValue(g3) && runfun.isValue(g4)) {
					// All four points found, so interpolate the value.
					return runfun.interpolation(i - fi, j - fj, g1, g2, g3, g4);
				}
			}
		}
		return null;

	}
})
L.Layer.runImg = function(data, option) {
	return new L.Layer.RunImg(data, option);
}